module.exports = "<p>\n  new-annonces works!\n</p>\n"